<template>
    <div style="width: 100vw; height: 100vh; display: flex; justify-content: center; align-items: center">
        <qrScanCode
            :sceneType="{
                login: 'log001',
                auth: 'bing001',
            }"
            scene="auth"
        />
    </div>
</template>
<script>
import qrScanCode from '@/components/qrScanCode.vue';
export default {
    components: {
        qrScanCode,
    },
    name: 'qrAuthPage',
    data() {
        return {};
    },
};
</script>
